import { useNavigate, useParams } from 'react-router-dom';
import StatsOverview from './StatsOverview';
import QuizStatTabs from './QuizStatTabs';

const QuizMetricsDashboard = () => {
  const navigate = useNavigate();
  const { quizId } = useParams<{ quizId: string }>();

  if (!quizId) {
    return (
      <div className="w-full p-10 text-center text-[16px] text-appTextLight">
        No quiz selected.
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex items-center justify-between pr-7">
        <div className="flex items-center w-full p-4 gap-3 border-b border-[#E2E8F0]">
          <i
            className="icon-arrow-up rotate-[-90deg] text-[24px] cursor-pointer"
            onClick={() => navigate('/quiz')}
          />
          <span className="text-[24px] font-medium">Quiz Metrics Dashboard</span>
        </div>
      </div>
      <StatsOverview quizId={quizId} />
      <QuizStatTabs quizId={quizId} />
    </div>
  );
};

export default QuizMetricsDashboard;
